import classNames from 'classnames';

const TextBlock = ({ children, className, isHtml }) => {
  const checkViewText = () => {
    if (isHtml) {
      return (
        <div
          className={classNames('text', className)}
          dangerouslySetInnerHTML={{ __html: children }}
        />
      );
    }

    return (
      <div
        className={classNames('text', className)}
        itemScope
        itemType='https://schema.org/Text'
      >
        {children}
      </div>
    );
  };

  return children ? checkViewText() : null;
};

export default TextBlock;
